import { render, staticRenderFns } from "./JgpDialog.vue?vue&type=template&id=b9d4bb8a&"
import script from "./JgpDialog.vue?vue&type=script&lang=js&"
export * from "./JgpDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports